import { render, staticRenderFns } from "./ShokurekishoJobImageCard.vue?vue&type=template&id=2b0445d6"
import script from "./ShokurekishoJobImageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoJobImageCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports